export default "__VITE_ASSET__D89nf8Ln__"